import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-orthopedic-card-features.js';

const SIDE_IMAGE = 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a0266b2189ec501d92419.png?w=1000&h=50&q=80';

const defaultItems = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a39fea730e6ff7367295162.png?w=200&h=50&q=80',
    content:
      '<h2><span style="font-size:24px;"><strong>Total Foot Relief</strong></span></h2><p><span style="font-size:22px;">Aching feet slowing you down? Our expert-designed cushioning for cloud-like comfort that lasts all day will help!</span></p>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a39fec6bac1b6c566236276.png?w=200&h=50&q=80',
    content:
      '<h2><span style="font-size:24px;"><strong>Plantar Fasciitis Support</strong></span></h2><p><span style="font-size:22px;">A sharp pain in the heel can ruin your morning! Our 98% Gel Damping Sole instantly soothes heel inflammation and sharp pain.</span></p>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a39fed8c419b305a1134179.png?w=200&h=50&q=80',
    content:
      '<h2><span style="font-size:24px;"><strong>Bunion & Wide-Foot Friendly</strong></span></h2><p><span style="font-size:22px;">Flexible, wide toe-box ends the squeeze and protects sensitive joints.</span></p>',
  },
];

const renderItem = item => `
  <div class="orthopedic-card-features__item" data-attribute="orthopedic-card-features__item">
    <div class="orthopedic-card-features__item-image-wrap">
      <img
        data-attribute="orthopedic-card-features__item-image"
        src="${item.image}"
        alt=""
      />
    </div>
    <div
      class="orthopedic-card-features__item-content"
      data-attribute="orthopedic-card-features__item-content"
    >
      ${item.content}
    </div>
  </div>`;

const contentHtml = `
  <div
    class="orthopedic-card-features"
    data-attribute="orthopedic-card-features-content"
    data-image-position="left"
    data-gap="8"
    data-background="#006196"
    data-text-color="#ffffff"
    style="
      --section-gap: 8px;
      --content-background: #006196;
      --content-text-color: #ffffff;
    "
  >
    <div class="orthopedic-card-features__image" data-attribute="orthopedic-card-features__image">
      <img
        data-attribute="orthopedic-card-features__image-img"
        src="${SIDE_IMAGE}"
        alt=""
      />
    </div>
    <div
      class="orthopedic-card-features__content"
      data-attribute="orthopedic-card-features__content"
    >
      <div
        class="orthopedic-card-features__header"
        data-attribute="orthopedic-card-features__header"
      >
        <h2>
          <span style="font-size: 38px"
            ><strong>PROVEN TO INCREASE&nbsp;</strong></span
          ><br /><span style="font-size: 38px"
            ><strong>COMFORT &amp; MOBILITY</strong></span
          >
        </h2>
        <p>
          <span style="font-size: 24px"
            >Stop letting foot pain dictate your day. Our orthopedic design targets
            the root cause of discomfort, giving you the freedom to move with zero
            pain.</span
          >
        </p>
      </div>

      <div class="orthopedic-card-features__list" data-attribute="orthopedic-card-features__list">
        ${defaultItems.map(renderItem).join('')}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: true,
});
